const USE_PRD_EMAIL = true;
const FROM_EMAIL= 'noreply@bainub.com';
const SEARCH_URL = 'https://files.bainub.com/search-products';
const GET_PRODUTCS_URL = 'https://files.bainub.com/get-products';
const FILES_URL = 'https://files.bainub.com/s3UploadFile';
const GET_SIGNED_URL = 'https://files.bainub.com/getSignedUrl';
const GET_SIGNED_B64_URL = 'https://files.bainub.com/getSignedUrlB64';
const NEW_USER_NOTIFICATION = 'https://files.bainub.com/pgFunctions/newUserNotifications'; 
const GET_SYSTEM_CONFIG_URL = 'https://files.bainub.com/pgFunctions/getSystemConfigurationData/';
const GET_MK_CATEGORY_DATA_URL = 'https://files.bainub.com/pgFunctions/getMkCategory/';
const IA_CHAT_ASSISTANT_URL = 'https://files.bainub.com/chat';
const GET_TOP_SEARCHES_URL = 'https://files.bainub.com/topSearch';
const GET_COMPANIES_URL = 'https://files.bainub.com/api/v1/companies';
const RFQ_API_URL = 'https://files.bainub.com/rfq';
const GET_PUBLIC_RFQS_URL = "https://files.bainub.com/rfq/public/all";
const SEARCH_COMPANIES_URL = 'https://search.bainub.com/search-companies';
const IS_DEV = false;
//12abril2025v2

export { USE_PRD_EMAIL, FROM_EMAIL, FILES_URL, GET_SIGNED_URL, GET_SIGNED_B64_URL, SEARCH_URL, 
    GET_PRODUTCS_URL, NEW_USER_NOTIFICATION, GET_SYSTEM_CONFIG_URL, IA_CHAT_ASSISTANT_URL, IS_DEV, GET_MK_CATEGORY_DATA_URL, GET_TOP_SEARCHES_URL,
    GET_COMPANIES_URL, RFQ_API_URL , GET_PUBLIC_RFQS_URL, SEARCH_COMPANIES_URL};